import React from 'react';
import { ecthr1 } from '../data/ecthr1.js';
import { ecthr2 } from '../data/ecthr2.js';
import { ecthr3 } from '../data/ecthr3.js';
import { ecthr4 } from '../data/ecthr4.js';
import { ecthr5 } from '../data/ecthr5.js';
import { ecthr6 } from '../data/ecthr6.js';
import { ecthr7 } from '../data/ecthr7.js';
import { ecthr8 } from '../data/ecthr8.js';
import CarouselSwiper from '../services/CarouselSwiper.jsx';
import '../styles/minute.css';
import '../styles/carousel.css';

const Procedures = () => {
    return (
        <div className="justified-text">
            <h5>Complaints to & decisions by any other international procedure</h5>
            <p>
                These are other application forms & decisions (the bundles are not included)
            </p>
            <h5>1. Introduced 22 August 2014</h5>
            <div>
                <br/>
                <CarouselSwiper images={ecthr1} />
            </div>
            <h5>2. Introduced 17 July 2015</h5>
            <div>
                <br/>
                <CarouselSwiper images={ecthr2} />
            </div>
            <h5>3. Introduced 12 August 2015</h5>
            <div>
                <br/>
                <CarouselSwiper images={ecthr3} />
            </div>
            <h5>4. Introduced 24 March 2016</h5>
            <div>
                <br/>
                <CarouselSwiper images={ecthr4} />
            </div>
            <h5>5. Introduced 28 April 2017</h5>
            <div>
                <br/>
                <CarouselSwiper images={ecthr5} />
            </div>
            <h5>6. Introduced 9 June 2018</h5>
            <div>
                <br/>
                <CarouselSwiper images={ecthr6} />
            </div>
            <h5>7. Introduced 6 July 2020</h5>
            <div>
                <br/>
                <CarouselSwiper images={ecthr7} />
            </div>
            <h5>8. Introduced 9 July 2021</h5>
            <div>
                <br/>
                <CarouselSwiper images={ecthr8} />
            </div>
        </div>
    );
};

export default Procedures;

